import { RefreshCw, FileText } from 'lucide-react';
import { connect } from 'react-redux';
import { TreatmentPlansActions } from 'store/actions';
import toast from 'react-hot-toast';
import { useState } from 'react';

let enhancer = connect(null, { ...TreatmentPlansActions });

const PdfViewerCard = ({ isRefreshing, onRefresh, generatePdf, setTreatmentPlan, treatmentPlan }) => {
  let { title, attachment, encoded_id } = treatmentPlan?.attributes || {}
  const [generating, setGenerating] = useState(false);

  const generateTxpPdf = async () => {
    setGenerating(true);
    try {
      const { data: _treatmentPlan } = await generatePdf(encoded_id);
      setTreatmentPlan(_treatmentPlan);
      toast.success("PDF generated successfully!");
    } catch (error) {
      toast.error(error.errors || "Failed to generate pdf");
    }
    setGenerating(false);
  };

  const Fallback = () => (
    <div className="absolute inset-0 flex items-center justify-center bg-white z-10">
      <div className="flex flex-col items-center gap-3 text-center px-6">
        <FileText size={40} className="text-secondary-300" />
        <h3 className="text-base font-bold text-secondary-700">{title}</h3>
        {generating ? (
          <div className="flex flex-col items-center gap-2">
            <span className="loading loading-spinner loading-md text-primary" />
            <p className="text-sm text-secondary-400">Generating PDF...</p>
          </div>
        ) : (
          <p className="text-sm text-secondary-400">
            TXP pdf is not present or expired.
            <br />
            Please{' '}
            <button
              onClick={generateTxpPdf}
              className="text-blue-600 font-medium underline underline-offset-2 hover:text-blue-700"
            >
              generate
            </button>{' '}
            it first
          </p>
        )}
      </div>
    </div>
  );

  if (!attachment) return <Fallback />

  return (
    <div className="card w-full bg-white border border-base-200 shadow-sm rounded-2xl hover:shadow-md transition-all duration-300 p-4">
      <div className="flex items-center justify-end mb-2">
        <button
          onClick={onRefresh}
          className="inline-flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-medium text-secondary-500 hover:text-secondary-700 hover:bg-secondary-50 rounded-lg transition-colors"
          title="Refresh PDF"
        >
          <RefreshCw size={14} />
          Refresh
        </button>
      </div>

      {isRefreshing ?
        <div className="w-full aspect-[8.5/11] border border-base-100 bg-white flex items-center justify-center">
          <span className="loading loading-spinner loading-md text-primary" />
        </div>
        :
        <div className="relative w-full overflow-hidden aspect-[8.5/11] border border-base-100 bg-white">
          <div
            className={`absolute inset-0 bg-white z-10 flex items-center justify-center transition-opacity duration-500 ease-in-out opacity-100`}
            style={{ animation: 'hideSpinner 0s ease-in 1s forwards' }}
          >
            <style>{`@keyframes hideSpinner { to { opacity: 0; visibility: hidden; pointer-events: none; }}`}</style>
            <span className="loading loading-spinner loading-md text-primary" />
          </div>

          <object
            data={`${attachment}#toolbar=0&navpanes=0&view=FitH`}
            type="application/pdf"
            className="absolute -top-[3%] -left-[3%] w-[106%] h-[106%] border-none overflow-hidden"
            style={{ colorScheme: 'light' }}
          >
            {<Fallback />}
          </object>
        </div>
      }
    </div>
  );
};

export default enhancer(PdfViewerCard);
